<ng-container *ngIf="isGreenCorner">
  <nz-spin [nzSpinning]="loading$ | async" [nzSize]="'small'">
    <nz-tag [nzColor]="'green'">
      {{
        'LOT_BIDDING_MODAL.GREEN_CORNER'
          | translate: { price: (greenCornerPrice$ | async | formatCurrency) }
      }}
    </nz-tag>
  </nz-spin>
</ng-container>
